module.exports = __webpack_public_path__ + "static/img/WI-1000XM2.281d6b7d.jpg";